// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"design_title__3bFGc","custom-control-label":"design_custom-control-label__zVN3Q"};